import { FC, PropsWithChildren } from 'react'

const Title: FC<PropsWithChildren> = ({ children }) => {
  return <h2>{children}</h2>
}

export default Title
